import useIsMobile from '@/hooks/useIsMobile';
import HomePageDesktop from './desktop';
import HomePageMobile from './mobile';
import { HomePageSettingProvider, useHomePageSetting, useHomePageSettingScreen } from './useHomePageSetting';

const HomePageSettingContent = () => {
    const isMobile = useIsMobile(992);
    const viewModel = useHomePageSettingScreen();

    if (isMobile) {
        return <HomePageMobile viewModel={viewModel} />;
    }

    return <HomePageDesktop viewModel={viewModel} />;
};

const HomePageSettingPage = () => {
    return (
        <HomePageSettingProvider>
            <HomePageSettingContent />
        </HomePageSettingProvider>
    );
};

export default HomePageSettingPage;
export { useHomePageSetting };